// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"ss_a bhk_a bhk_r bhk_j","Photos__img":"ss_b bhk_b"};